module.exports = __webpack_public_path__ + "img/live-event.d65c2e6d.svg";